<template>
    <div v-if="listStyle.common" class="minisite-list-14" :class="'template-' + listStyle.templateId">
        <div class="list-search" v-show="getShowedComponent && getShowedComponent.search">
            <search-component
                @search="search"
                :settings="data.search"
                v-model="searchWord"
                :search-style="listStyle.searchStyle"></search-component>
        </div>
        <div class="list-content">
            <div
                v-for="(item, itemIndex) in filterData"
                :key="item.id"
                class="minisite-list-item"
                :style="{ width: listStyle.common.width + '%' }">
                <click-action
                    :type="data.type"
                    class="main-item-content"
                    :style="getCommonStyle"
                    :data="item.clickAction"
                    :key="item.id">
                    <div
                        v-if="getShowedComponent.image"
                        class="left-container"
                        :style="[getImageStyle, { height: blockHeight }]">
                        <div class="image-container" :style="[{ width: listStyle.imageStyle.width + '%' }]">
                            <basic-image
                                :data="item.image"
                                :image-style="listStyle.imageStyle"
                                :image-title-style="listStyle.imageTitleFontStyle"></basic-image>
                            <div
                                v-show="getShowedComponent.collection"
                                class="image-collection"
                                :style="{ backgroundColor: listStyle.collectionStyle.backgroundColor }">
                                <collection
                                    :data="item.button"
                                    @collection-status-change="
                                        collectionStatusChange({
                                            item,
                                            collectionId: `${_pageId}_${data.id}_${item.id}`,
                                            showedStatus: getShowedComponent
                                        })
                                    "
                                    :item-id="`${_pageId}_${data.id}_${item.id}`"
                                    :collection-style="listStyle.collectionStyle"></collection>
                            </div>
                            <div
                                v-show="getShowedComponent.title"
                                class="title-container"
                                :style="[{ width: listStyle.titleFontStyle.width + '%' }, getTitleRadius]">
                                <basic-text :data="item.title" :font-style="listStyle.titleFontStyle"></basic-text>
                            </div>
                        </div>
                    </div>
                </click-action>
                <div
                    class="divide-line"
                    :style="getDivideStyle"
                    v-show="getShowedComponent.divideLine && itemIndex < filterData.length - 1">
                </div>
            </div>
        </div>
        <div class="minisite-list-item" :style="{ width: listStyle.common.width + '%' }"></div>
        <div class="minisite-list-item" :style="{ width: listStyle.common.width + '%' }"></div>
        <div class="minisite-list-item" :style="{ width: listStyle.common.width + '%' }"></div>
        <div class="minisite-list-item" :style="{ width: listStyle.common.width + '%' }"></div>
    </div>
</template>

<script>
    import listMixin from "./list.mixin"

    export default {
        name: "ListTemplate14",
        mixins: [listMixin],
        props: {
            data: {}
        },
        data() {
            return {
                listStyle: {},
                blockHeight: "initial"
            }
        },
        computed: {
            getTitleRadius() {
                const radius = this.listStyle.imageStyle.borderRadius
                return Object.assign(
                    {},
                    {
                        borderRadius: radius <= 0 ? "0 0 20px 0" : `${radius}px 0 ${radius}px 0`,
                        overflow: "hidden"
                    }
                )
            }
        },
        mounted() {
            this.listStyle = this.data.style
        }
    }
</script>

<style lang="less" scoped>
    .minisite-list-14 {
        .list-content {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: flex-start;
        }

        .minisite-list-item {
            display: flex;
            flex-direction: column;
        }

        .main-item-content {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            overflow: hidden;
        }

        .title-container {
            position: absolute;
            top: 0;
            left: 0;
            //width: 100%;
            max-width: 80%;
        }

        .left-container {
            flex-grow: 0;
            flex-shrink: 0;
            width: 100%;
            display: flex;
            justify-content: center;
            position: relative;

            .image-container {
                display: flex;
                align-items: center;
                justify-content: center;

                .image-collection {
                    width: 32px;
                    height: 32px;
                    border-radius: 0 0 4px 4px;
                    position: absolute;
                    top: 0px;
                    right: 8px;
                }
            }
        }

        .button-container {
            width: 100%;
        }

        .right-container {
            width: 100%;
        }

        .right-icon {
            margin-left: 10px;
            flex-shrink: 0;

            .icon-image {
                max-width: 50px;
            }
        }
    }
</style>
